module.exports = __webpack_public_path__ + "static/media/Background@3x.60b131be.jpg";